module.exports = "pegasus/assets/themelp1/small/35.png";